import React, { memo } from "react";
import {
  AppBar,
  AppBarProps,
  IconButton,
  Toolbar,
  Typography,
  Hidden,
  Box,
} from "@material-ui/core";
import useDashboardAppBar from "./index.hooks";
import MenuIcon from "@material-ui/icons/Menu";
import { AppButton, AppSelect, LanguageMenu } from "components";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

type DashboardAppBarProps = {
  onMenuIconPressed: () => void;
} & AppBarProps;

const DashboardAppBar = ({
  onMenuIconPressed,
  ...props
}: DashboardAppBarProps) => {
  const {
    styles,
    merchantId,
    handleMerchantChange,
    merchantsOptions,
    handleLogout,
    t,
  } = useDashboardAppBar();

  return (
    <AppBar {...props} className={styles.appBar}>
      <Toolbar>
        <Hidden smUp implementation="css">
          <IconButton
            edge="start"
            onClick={onMenuIconPressed}
            className={styles.menuIcon}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Typography variant="h6">{t("Gestione")}</Typography>
        <div className={styles.barContainer}>
          <div className={styles.selectorContainer}>
            <AppSelect
              value={merchantId}
              onChange={handleMerchantChange}
              options={merchantsOptions}
            />
          </div>
          <LanguageMenu />
          <Hidden xsDown implementation={"css"}>
            <AppButton
              endIcon={<ExitToAppIcon />}
              onClick={handleLogout}
              className={styles.logoutButton}
              variant={"contained"}
              color={"secondary"}
            >
              {t("Log out")}
            </AppButton>
          </Hidden>
          <Hidden smUp implementation={"css"}>
            <ExitToAppIcon
              onClick={handleLogout}
              className={styles.mobileLogoutButton}
            />
          </Hidden>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default memo(DashboardAppBar);
